import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import { take, put, call, all } from 'redux-saga/effects';
import { setStrings, setFragments } from 'wfui-digital-core/es/actions';
import { LANGUAGE_REQUEST, setLanguage } from '../language/actions';
import fetchStrings from '../../fetch-strings/fetch-strings';
import fetchFragments from '../../fetch-fragments/fetch-fragments';
import { showModuleError } from '../module-error/actions';
import logger from '../../logger/logger';
export var watchLanguage = /*#__PURE__*/regeneratorRuntime.mark(function watchLanguage() {
  var _yield$take, language, _yield$all, _yield$all2, strings, fragments;

  return regeneratorRuntime.wrap(function watchLanguage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 28;
            break;
          }

          _context.next = 3;
          return take(LANGUAGE_REQUEST);

        case 3:
          _yield$take = _context.sent;
          language = _yield$take.language;
          _context.prev = 5;
          _context.next = 8;
          return all([call(fetchStrings, language), call(fetchFragments, language)]);

        case 8:
          _yield$all = _context.sent;
          _yield$all2 = _slicedToArray(_yield$all, 2);
          strings = _yield$all2[0];
          fragments = _yield$all2[1];
          _context.next = 14;
          return put(setLanguage(language));

        case 14:
          _context.next = 16;
          return put(setStrings(strings));

        case 16:
          _context.next = 18;
          return put(setFragments(fragments));

        case 18:
          _context.next = 26;
          break;

        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](5);
          _context.next = 24;
          return logger.error('Error loading static content', _context.t0);

        case 24:
          _context.next = 26;
          return put(showModuleError());

        case 26:
          _context.next = 0;
          break;

        case 28:
        case "end":
          return _context.stop();
      }
    }
  }, watchLanguage, null, [[5, 20]]);
});